import React, { useEffect, useState } from 'react';
import { CalendarOff } from 'lucide-react';

// Fermeture estivale 2026. FIN = premier jour de RÉOUVERTURE (borne exclusive).
// Pour désactiver hors période : mettre DEBUT = FIN.
const CONGES = {
  DEBUT: '2026-08-10',
  FIN: '2026-08-24',
  TITRE: "Congés d'été du 10 au 23 août",
  MESSAGE:
    'Les commandes passées pendant cette période sont préparées et expédiées à partir du lundi 24 août.',
};

// "2026-08-10" → 10 août 2026 à 00:00 heure LOCALE.
// new Date("2026-08-10") serait lu en UTC, soit 02:00 à Paris en été.
function parseLocalDay(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function isVacationActive(now = new Date()) {
  const debut = parseLocalDay(CONGES.DEBUT);
  const fin = parseLocalDay(CONGES.FIN);
  return now >= debut && now < fin;
}

// ⚠️ Volontairement INDÉPENDANT de `maintenance.enabled` : ce drapeau masque le
// bouton « Ajouter au panier » et le sélecteur de quantité (ProductDetail.js).
// Annoncer les congés ne doit en aucun cas fermer la vente — les commandes
// restent ouvertes et partent à la réouverture. Ne pas fusionner les deux.
export default function VacationBanner({ now }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const apercu = new URLSearchParams(window.location.search).has('apercu-conges');
    setVisible(apercu || isVacationActive(now));
  }, [now]);

  if (!visible) return null;

  return (
    <div
      role="status"
      data-testid="vacation-banner"
      className="bg-white/5 border-b border-white/15"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-center">
        <CalendarOff className="w-4 h-4 shrink-0 text-secondary" aria-hidden="true" />
        <p className="text-[11px] sm:text-xs text-slate-300 leading-snug">
          <span className="font-accent uppercase tracking-widest text-white">
            {CONGES.TITRE}
          </span>
          <span className="hidden sm:inline"> — </span>
          <span className="block sm:inline">{CONGES.MESSAGE}</span>
        </p>
      </div>
    </div>
  );
}
